export const DEFAULT_RR: number = 0;